<template>
  <div v-if="$store.getters['loaderCartState'] == true">
    <div class="loader-container">
      <div class="loader">
        <i></i>
      </div>
    </div>
    <div class="overlay">
      <i></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderCart",
  props: ["visible"]
};
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: white; z-index: 800; }

  .loader-container{ position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; z-index: 900; justify-content: center; align-items: center; }

  .logo{ margin-bottom: 30px; }

  .loader {
    background-color: $color3;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    text-align: center;
    i {
      display: block;
      margin: 0 auto;
      &:before {
        content: ".";
        animation-name: load;
        animation-duration: 800ms;
        animation-iteration-count: infinite;
        width: auto;
        color: white;
        display: inline-block;
        font-size: 24px;
      }
    }
  }

  @keyframes load {
    0% {
      content: ".";
    }
    33% {
      content: "..";
    }
    66% {
      content: "...";
    }
    100% {
      content: ".";
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Global/LoaderCart.vue